import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import { CategoryStoreModel } from "../../../../models/store/category.store.model";
import { CategoryResponse } from "../../../../models/data/response/category.response";
import { Category } from "../../../../models/data/blobby/category.data";
import { category_v0_to_v1, category_v1_to_v2 } from "../model-dto/category";

export class CategoryParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported Category parser version ${version}`);
    }

    if (version === 0) {
      return CategoryParser_v0;
    } else if (version === 1) {
      return CategoryParser_v1;
    } else {
      return CategoryParser_v2;
    }
  }

  override getSupportedVersion(): number[] {
    return [0, 1, 2];
  }
}

const CategoryParser_v2 = (categoryItem: any): CategoryStoreModel =>
  categoryItem as CategoryStoreModel;

const CategoryParser_v1 = (categoryItem: any): CategoryStoreModel => {
  const upgraded = category_v1_to_v2(categoryItem);
  return CategoryParser_v2(upgraded);
};

const CategoryParser_v0 = (categoryItem: any): CategoryStoreModel => {
  const response = new CategoryResponse(categoryItem);
  const category = new Category(response);
  const upgraded = category_v0_to_v1(category);
  /** We need to remap the vid properties as this is new and was not map in the previous blobby type **/
  upgraded.vid = categoryItem.vid ?? "";
  return CategoryParser_v1(upgraded);
};
